import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'CP',
};

type CPAuditHistoryLoc =
	| 'CPAuditHistoryTitle'
	| 'CPAuditHistoryDescription'
	| 'CPAuditHistoryStarted'
	| 'CPAuditHistoryStatus'
	| 'CPAuditHistoryDue'
	| 'CPAuditHistoryCompleted'
	| 'CPAuditHistoryActions'
	| 'CPAuditHistoryViewMore';

export const cpAuditHistoryLocs: LocDefs<CPAuditHistoryLoc> = {
	CPAuditHistoryTitle: {
		defaultValue: 'Audit History',
		description: 'Page title for the audit history.',
		displayPath: `History|Audit|Title`,
		displayType: 'Title',
		...sharedProps,
	},
	CPAuditHistoryDescription: {
		defaultValue: '',
		description: 'Description for the audit history.',
		displayPath: `History|Audit|Description`,
		displayType: 'Content',
		...sharedProps,
	},
	CPAuditHistoryStarted: {
		defaultValue: 'Started',
		description: 'Started for the audit history.',
		displayPath: `History|Audit|Started`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryStatus: {
		defaultValue: 'Status',
		description: 'Status for the audit history.',
		displayPath: `History|Audit|Status`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryDue: {
		defaultValue: 'Due',
		description: 'Due for the audit history.',
		displayPath: `History|Audit|Due`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryCompleted: {
		defaultValue: 'Completed',
		description: 'Completed for the audit history.',
		displayPath: `History|Audit|Completed`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryActions: {
		defaultValue: '',
		description: 'Actions for the audit history.',
		displayPath: `History|Audit|Actions`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryViewMore: {
		defaultValue: 'View',
		description: 'View more action button.',
		displayPath: `History|Audit|View More`,
		displayType: 'Button',
		...sharedProps,
	},
};

export const cpAuditHistoryLocKeys = MapLocKeys<CPAuditHistoryLoc>(cpAuditHistoryLocs);
export type CPAuditHistoryLocKeys = typeof cpAuditHistoryLocKeys;
